import { Box, Divider, FormLabel } from "@chakra-ui/react";
import { ColumnDef } from "@tanstack/react-table";
import ActiveTag from "components/ui/ActiveTag";
import ButtonCreateNew from "components/ui/ButtonCreateNew";
import FilterGroup from "components/ui/FilterGroup";
import HeaderBar from "components/ui/HeaderBar";
import SearchInput from "components/ui/SearchInput";
import DynamicTableProvider, {
  useDynamicTableContext,
} from "contexts/DynamicTableContext";
import LayoutParameters from "features/auth/layouts/LayoutParameters";
import React from "react";
import PeopleList from "../components/PeopleList";

export default function PagePeople() {
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        header: "Nome",
        accessorKey: "name",
      },
      {
        header: "Status",
        accessorKey: "active",
        cell: ({ row }) => <ActiveTag isActive={row.original.active} />,
      },
    ],
    []
  );
  return (
    <LayoutParameters>
      <DynamicTableProvider
        columns={columns}
        resource={{
          resourceName: "people",
        }}
        tableOptions={{
          enableGlobalFilter: false,
        }}
      >
        <HeaderBar
          title="Report → Parlamentares"
          description="Visualize a lista de parlamentares Patri"
          px="0"
          sx={{
            h1: {
              mt: "0",
            },
          }}
        >
          <ButtonCreateNew title="Cadastrar novo" to="/parlamentares/novo" />
        </HeaderBar>

        <Divider />

        <Box pt="24px">
          <Filters />
          <PeopleList />
        </Box>
      </DynamicTableProvider>
    </LayoutParameters>
  );
}

function Filters() {
  const { table } = useDynamicTableContext();

  return (
    <FilterGroup justifyContent="space-between" pos="relative">
      <Box flex={1} minW="180px">
        <FormLabel>Buscar</FormLabel>
        <SearchInput
          placeholder="Buscar por nome"
          onChange={(value) =>
            table.getColumn("name")?.setFilterValue(String(value))
          }
        />
      </Box>
    </FilterGroup>
  );
}
